import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { helper } from 'src/environments/helper';
import { DocumentCategoryService } from '../document-category.service';
import { NotificationService } from 'src/app/services/notification.service';
import { finalize, map, Observable } from 'rxjs';
import { IAddDocumentCategoryPayload, IFormDocumentCategory } from '../document-category.interface';
import { Generic } from 'src/app/interfaces/generic.interface';

@Component({
    selector: 'app-add-document-category',
    templateUrl: './add-document-category.component.html',
    styleUrls: ['./add-document-category.component.scss']
})
export class AddDocumentCategoryComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    defaultParameter: { name: string; id: string } = {
        name: '--Alegeți--',
        id: '-1',
    };

    documentCategories$!: Observable<Generic[]>;

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        slug: new FormControl('', [Validators.required]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddDocumentCategoryComponent>,
        private documentCategoryService: DocumentCategoryService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit(): void { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    submitForm() {
        this.isLoading = true;

        const { name, slug } = this.form.value as IFormDocumentCategory;
        const payload: IAddDocumentCategoryPayload = {
            name,
            slug
        };

        this.documentCategoryService
            .addDocumentCategory(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
